import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Language } from '@mui/icons-material';
import { Box, IconButton, Tooltip } from '@mui/material';
import { getFlagForLanguage } from '../../../utils/flag-utils';

import GameExpiredAlert from './index';

interface GameExpiredOverlayProps {
  isVisible: boolean;
}

const GameExpiredOverlay: FC<GameExpiredOverlayProps> = ({ isVisible }) => {
  const { i18n, t } = useTranslation();
  const [, forceUpdate] = useState({});

  const toggleLanguage = () => {
    console.log('Current language:', i18n.language);
    const languages = ['ru-RU', 'en-EN', 'es-ES', 'de-DE', 'fr-FR'];
    const currentIndex = languages.indexOf(i18n.language);
    const nextIndex = (currentIndex + 1) % languages.length;
    const newLang = languages[nextIndex];
    console.log('Switching to:', newLang);
    i18n.changeLanguage(newLang).then(() => {
      console.log('Language changed to:', i18n.language);
      forceUpdate({}); // Принудительно перерендериваем компонент
    });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2,
      }}
    >
      <Box sx={{ position: 'relative' }}>
        {/* Кнопка переключения языка */}
        <Box
          sx={{
            position: 'absolute',
            top: -50,
            right: 0,
            zIndex: 10000,
          }}
        >
          <Tooltip title={`${t('clientAll.switchLanguage')} (${getFlagForLanguage(i18n.language)})`} arrow placement="left">
            <IconButton
              onClick={toggleLanguage}
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                color: '#3b82f6',
                fontSize: '0.875rem',
                fontWeight: 500,
                minWidth: '40px',
                height: '40px',
                borderRadius: '6px',
                border: '1px solid #ddd',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 1)',
                  color: '#1d4ed8',
                },
              }}
            >
              {getFlagForLanguage(i18n.language)}
            </IconButton>
          </Tooltip>
        </Box>

        <GameExpiredAlert />
      </Box>
    </Box>
  );
};

export default GameExpiredOverlay; 